import type { OrderTimelineEvent } from '@nebalkon-workspace/order-api';

export interface OrderTimelineEventPresentation {
  titleKey: string;
  titleParams?: Record<string, string>;
  detail?: string;
}

const EVENT_TITLE_KEYS: Record<string, string> = {
  status_changed: 'staff.orders.cockpit.timeline.events.statusChanged',
  movers_assigned: 'staff.orders.cockpit.timeline.events.moversAssigned',
  movers_reassigned: 'staff.orders.cockpit.timeline.events.moversReassigned',
  details_changed: 'staff.orders.cockpit.timeline.events.detailsChanged',
  note_added: 'staff.orders.cockpit.timeline.events.noteAdded',
  completed: 'staff.orders.cockpit.timeline.events.completed',
  canceled: 'staff.orders.cockpit.timeline.events.canceled',
};

export function orderTimelineEventPresentation(
  event: OrderTimelineEvent,
  // eslint-disable-next-line no-unused-vars
  statusLabel: (_: string) => string,
): OrderTimelineEventPresentation {
  const titleKey =
    EVENT_TITLE_KEYS[event.event_type] ??
    'staff.orders.cockpit.timeline.events.unknown';

  switch (event.event_type) {
    case 'status_changed': {
      const oldStatus = String(event.payload['old_status'] ?? '');
      const newStatus = String(event.payload['new_status'] ?? '');
      return {
        titleKey,
        titleParams: {
          oldStatus: statusLabel(oldStatus),
          newStatus: statusLabel(newStatus),
        },
      };
    }
    case 'note_added': {
      const text = String(event.payload['text'] ?? '').trim();
      return {
        titleKey,
        detail: text || undefined,
      };
    }
    case 'canceled': {
      const reason =
        event.reason?.trim() ||
        String(event.payload['cancel_reason'] ?? '').trim();
      return {
        titleKey,
        detail: reason || undefined,
      };
    }
    case 'details_changed':
    case 'movers_reassigned':
      return {
        titleKey,
        detail: event.reason?.trim() || undefined,
      };
    default:
      return { titleKey };
  }
}
